export default __webpack_public_path__ + "static/media/views_left.932ebcd3.svg";